
import React, { useEffect, useState } from 'react'
import { Button, Input, message, Popover, Space, Table, Tooltip } from 'antd'
import axios from 'axios'
import { useLocation } from 'react-router-dom';
import AdminProfile from './AdminProfile';
import NewTransactionTable from './NewTransactionTable';
import Model from '../Layout/Model';
const { Search } = Input;


const Api = (props) => {
  const [searchText, setSearchText] = useState('');
  const { userName, formSubmitted, filter } = props;
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [statusFilterValue, setStatusFilterValue] = useState("TRADE");
  const [levelFilter, setLevelFilter] = useState(null);
  const [UsernameFilter, setUsernameFilter] = useState(null);
  const [dateFilter, setdateFilter] = useState(null);
  const [TransidFilter, setTransidFilter] = useState(null);
  const location = useLocation();
  const { profile } = AdminProfile()
  const [profileAvatar, setProfileAvatar] = useState(profile?.Adminname);
  const [gatewayFilter, setGatewayFilter] = useState(null);
  const [assetsFilter, setAssetsFilter] = useState(null);

  const ViewTotalLevel = (statusFilterValue, usernameValue, form_by, datefilter, transidValue) => {
    const jwt = localStorage.getItem('jwt');

    const postData = {
      jwt: jwt,
      page_no: page,
      page_size: size,
      exchange_type: filter === "ALL" ? ["SPOT", "FUTURES"] : [filter],
    };

    if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
      postData.username = [userName];
    }

    if (datefilter !== null && datefilter.length > 0) {
      postData.date = datefilter;
    }

    // if (location.pathname === '/dashboard/activeuser') {
    //     postData.pack = [FilterValue];
    // } else if (statusFilterValue !== null && statusFilterValue !== undefined) {
    //     postData.pack = [statusFilterValue];
    // }

    if (form_by !== null && form_by !== undefined) {
      postData.by = [form_by]
    }
    if (usernameValue !== null && usernameValue !== undefined) {
      if (/^\d+$/.test(usernameValue)) {
        postData.transid = [usernameValue];
      } else {
        postData.username = [usernameValue];
      }
    }

    if (transidValue !== null && transidValue !== undefined) {
      postData.transid = [transidValue];
    }

    axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_API + '/bot/total_page_view_apis',
      data: postData
    }).then(res => {
      setTotalPages(res?.data?.Success);
      // props.formSubmitted(totalPages)
    }).catch(err => {
      console.log(err);
    });
  };

  const ViewLevel = (statusFilterValue, usernameValue, form_by, datefilter, transidValue) => {
    const jwt = localStorage.getItem('jwt');

    const postData = {
      jwt: jwt,
      page_no: page,
      page_size: size,
      exchange_type: filter === "ALL" ? ["SPOT", "FUTURES"] : [filter],
      // username: location.pathname === '/UpdateUser' ? [userName] : [userName],
      // by: location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' ? [profileAvatar] : ""

      // by: [profileAvatar, "User"]
    };
    if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
      postData.username = [userName];
    }

    if (datefilter !== null && datefilter.length > 0) {
      postData.date = datefilter;
    }

    // if (location.pathname === '/dashboard/activeuser') {
    //     postData.pack = [FilterValue];
    // } else if (statusFilterValue !== null && statusFilterValue !== undefined) {
    //     postData.pack = [statusFilterValue];
    // }


    if (form_by !== null && form_by !== undefined) {
      postData.by = [form_by]
    }
    if (usernameValue !== null && usernameValue !== undefined) {
      if (/^\d+$/.test(usernameValue)) {
        postData.transid = [usernameValue];
      } else {
        postData.username = [usernameValue];
      }
    }

    if (transidValue !== null && transidValue !== undefined) {
      postData.transid = [transidValue];
    }

    axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_API + '/bot/view_apis',
      data: postData
    }).then(res => {
      if (res?.data?.Success === "No transactions yet!") {
        setData([]);
        // message.info("No transactions yet!");
      } else {
        setData(res?.data?.Success);
        // props.formSubmitted(data)
      }
    }).catch(err => {
      // message.error(err);
    });
  };



  useEffect(() => {
    if (userName) {
      ViewTotalLevel(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, filter);
      ViewLevel(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, filter);
    }
  }, [page, size, statusFilterValue, formSubmitted, dateFilter, UsernameFilter, TransidFilter, filter, gatewayFilter, assetsFilter, userName]);


  const [statusWalletModal, setStatusWalletModal] = useState(false)
  const [selectedData, setSelectedData] = useState()

  const [recordValue, setRecordValue] = useState("")
  const WalletPasswordUpdate = (value) => {
    setRecordValue(value)
    setStatusWalletModal(true)
  }

  const columns = [
    {
      title: "Datetime",
      dataIndex: "Created_At",
      key: "Created_At",
      width: undefined,
      className: "whitespace-nowrap ",
    },
    {
      title: "API ID",
      dataIndex: "API_ID",
      key: "API_ID",
      width: undefined,
      className: "whitespace-nowrap ",
    },
    {
      title: "API Name",
      dataIndex: "API_Name",
      key: "API_Name",
      width: undefined,
      className: "whitespace-nowrap ",
    },

    {
      title: "Exchange",
      dataIndex: "Exchange",
      key: "Exchange",
      width: undefined,
      className: "whitespace-nowrap ",
    },
    {
      title: "Exchange Type",
      dataIndex: "Exchange_Type",
      key: "Exchange_Type",
      width: undefined,
      className: "whitespace-nowrap ",
    },
    {
      title: 'Trade Type',
      dataIndex: 'Trade_Type',
      key: 'Trade_Type',
      width: undefined,
      className: "whitespace-nowrap ",
    },
    {
      title: 'Total Investment',
      dataIndex: 'Total_Investment',
      key: 'Total_Investment',
      width: undefined,
      className: "whitespace-nowrap ",
    },

    {
      title: 'Account Balance',
      dataIndex: 'Account_Balance',
      key: 'Account_Balance',
      width: undefined,
      className: "whitespace-nowrap ",
    },
    {
      title: 'Approved',
      dataIndex: 'Approved',
      key: 'Approved',
      width: undefined,
      className: "whitespace-nowrap ",
    },
    {
      title: "Stop API", dataIndex: "stop", key: "stop", className: "whitespace-nowrap ",
      render: (text, record) => {
        return (
          <div className='flex items-center gap-3'>
            <button
              onClick={() => {
                WalletPasswordUpdate(record.API_ID);
              }}
              className="text-black"
            >
              Click
            </button>
          </div>
        )
      }
    },
    // {
    //   title: "Stop API",
    //   dataIndex: "stop",
    //   key: "stop",
    //   className: "whitespace-nowrap",
    //   render: (text, record) => {
    //     const confirmAction = () => {
    //       WalletPasswordUpdate(record.API_ID);
    //     };
  
    //     const popoverContent = (
    //       <div className="flex flex-col gap-2">
    //         <span>Are you sure?</span>
    //         <div className="flex justify-end gap-2">
    //           <Button size="small" onClick={() => confirmAction()} type="primary">
    //             Yes
    //           </Button>
    //           <Button size="small" onClick={() => document.body.click()} type="default">
    //             No
    //           </Button>
    //         </div>
    //       </div>
    //     );
  
    //     return (
    //       <div className="flex items-center gap-3">
    //         <Popover content={popoverContent} trigger="click">
    //           <button className="text-black">Click</button>
    //         </Popover>
    //       </div>
    //     );
    //   },
    // },
    {
      title: 'Status',
      dataIndex: 'Status',
      key: 'Status',
      width: undefined,
      className: "whitespace-nowrap ",
      render: (text, record) => {
        return text === "ACTIVE" ? (
          <button
            // onClick={() => showModal(record.API_Name, record.API_ID)}
            className='text-[#008000] px-3 rounded-xl'
          >
            {text}
          </button>
        ) : (
          <button
            className='text-[rgb(255,0,0)] px-3 rounded-xl'
          >
            {text}
          </button>
        );
      },
    }
  ];


  const dataSource = data.map((item, index) => ({
    Serial: index + 1,
    Created_At: item?.Created_At,
    API_ID: item?.API_ID,
    API_Name: item?.API_Name,
    Name: item?.Name,
    Exchange: item?.Exchange,
    Exchange_Type: item?.Exchange_Type,
    Trade_Type: item?.Trade_Type,
    Total_Investment: item?.Total_Investment,
    Account_Balance: item?.Account_Balance,
    Approved: item?.Approved,
    Status: item?.Status,
    // ROI_Validity: item?.ROI_Validity,
  }));

  const handleWalletStatus = (values) => {
    const jwt = localStorage.getItem('jwt')
    const postData = {
      jwt: jwt,
      username: userName,
      api_id: recordValue,
      reason: values?.fundComment
    }

    const response = axios({
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      url: process.env.REACT_APP_API + "/bot/stop_api",
      data: postData
    }).then(response => {
      const responseData = response?.data
      if (responseData?.Success) {
        message.success(responseData?.Success)
        setStatusWalletModal(false)
        ViewTotalLevel(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, filter);
        ViewLevel(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, TransidFilter, filter);
      } else {
        message.error(responseData?.Success)
      }
    }).catch(err => {
      message.error(err?.response?.data?.Error)
    })
  }



  const handleSearch = (value) => {
    setSearchText(value);
  };

  const prepareDataForCSV = () => {
    const csvData = Array.isArray(data) ? data.map((item, index) => ({
      Serial: index + 1,
      Created_At: item?.Created_At || "--",
      API_ID: item?.API_ID || "--",
      API_Name: item?.API_Name || "--",
      Name: item?.Name || "--",
      By: item?.By || "--",
      Exchange: item?.Exchange || "--",
      Exchange_Type: item?.Exchange_Type || "--",
      Trade_Type: item?.Trade_Type || "--",
      Total_Investment: item?.Total_Investment || "--",
      Account_Balance: item?.Account_Balance || "--",
      Approved: item?.Approved || "--",
      Status: item?.Status || "--"
    })) : [];

    return csvData;
  };

  const handleStatusCancelWallet = () => {
    setStatusWalletModal(false);
  };

  const handleLevelFilter = (value) => {
    setLevelFilter(value);
  };


  return (
    <>
      <div className='mt-5'>

        <NewTransactionTable data={data} handleSearch={handleSearch} prepareDataForCSV={prepareDataForCSV} onSearch={handleSearch} setData={setData} onLevelChange={handleLevelFilter} columns={columns} dataSource={dataSource} totalPages={totalPages} page={page} size={size} setPage={setPage} setSize={setSize} />
      </div>
      <Model
        title={<div className='flex justify-between mr-5 items-center'>
          <p>Stop API</p>
          <Tooltip className='cursor-pointer'>
            <div>API ID: <span className='font-light'>{recordValue}</span></div>
          </Tooltip>
        </div>}
        open={statusWalletModal}
        onCancel={handleStatusCancelWallet}
        onFinish={handleWalletStatus}

        label1="Reason"
        name1="fundComment"
        placeholder1="Enter Reason"
        isRequired1={true}
      />
    </>
  )
}

export default Api
